import React from 'react';

class StateSelector extends React.Component {
	statesToShow = [];

	constructor(props){
		super(props);

		this.onLeftClick = this.onLeftClick.bind(this); //left and right are direction of arrow not mouse click sorry for confusion
		this.onRightClick = this.onRightClick.bind(this);

		this.statesFull = [
			"Alaska", "Alabama", "Arkansas", "Arizona", "California", "Colorado", "Connecticut", "DC", "Deleware", "Florida",
			"Georgia", "Hawaii", "Iowa", "Idaho", "Illinois", "Indiana", "Kansas", "Kentucky", "Louisiana", "Massachusetts",
			"Maryland", "Maine", "Michigan", "Minnesota", "Missouri", "Mississippi", "Montana", "North Carolina", "North Dakota",
			"Nebraska", "New Hampshire", "New Jersey", "New Mexico", "Nevada", "New York", "Ohio", "Oklahoma", "Oregon", "Pennsylvania",
			"Rhode Island", "South Carolina", "South Dakota", "Tennessee", "Texas", "Utah", "Virginia", "Vermont", "Washington", "Wisconsin",
			"West Virginia", "Wyoming"
		];

		this.statesArr = [
					"AK", "AL", "AR", "AZ", "CA", "CO", "CT", "DC", "DE", "FL", "GA", "HI", "IA", "ID", "IL",
					"IN", "KS", "KY", "LA", "MA", "MD", "ME", "MI", "MN", "MO", "MS", "MT", "NC", "ND", "NE", 
					"NH", "NJ", "NM", "NV", "NY", "OH", "OK", "OR", "PA", "RI", "SC", "SD", "TN", "TX", "UT",
					"VA", "VT", "WA", "WI", "WV", "WY"
				];

	}

	onLeftClick(e) {
		if(this.props.onLeftClick) this.props.onLeftClick(e);
	}

	onRightClick(e) {
		if(this.props.onRightClick) this.props.onRightClick(e);
	}

	render() {

		const stateToShow = (this.props.index < this.props.states.length) ? this.props.states[this.props.index] : this.props.states[0];
		const fullStateName = this.statesFull[this.statesArr.indexOf(stateToShow)];

		return (
			<div className='state-select-div'>
				<div className='state-left-div' onClick={this.onLeftClick}><img src={process.env.PUBLIC_URL + "images/white-arrow@2x.png"} alt='scroll state left' /></div>
				<div className='state-selector'>
					{fullStateName}
				</div>
				<div className='state-right-div' onClick={this.onRightClick}><img src={process.env.PUBLIC_URL + "images/white-arrow@2x.png"} alt='scroll state right' /></div>
			</div>
		);
	}
}

export default StateSelector;